import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Collapse from 'antd/lib/collapse';
import DocumentsList from './DocumentsList';

const CollapsePanel = Collapse.Panel;

const DocumentsCollapse = ({ contracts, token, t, accountRole }) => (
  <Collapse>
    <CollapsePanel header={t('Zobraziť zmluvy')}>
      <DocumentsList documents={contracts} token={token} accountRole={accountRole} />
    </CollapsePanel>
  </Collapse>
);

DocumentsCollapse.propTypes = {
  contracts: PropTypes.array.isRequired,
  token: PropTypes.string.isRequired,
  accountRole: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(DocumentsCollapse);



// WEBPACK FOOTER //
// ./src/common/components/data-display/DocumentsCollapse.js